import styled from 'styled-components';
import { mediaBreakpointMixin, PageContent, spaceMixin, Spacer, Tabs, token } from '@zillow/constellation';

export const StyledHeaderContainer = styled.div`
  background-color: ${token('colors.white')};
  border-bottom: 1px solid ${token('colors.borderLight')};
`;

export const StyledNavigationContainer = styled.div`
  background-color: ${token('colors.white')};
`;

export const StyledHeaderPageContent = styled(PageContent)`
  margin: 0 auto;
  padding-top: ${spaceMixin('sm')};
  padding-left: 0;
  padding-right: 0;

  @media ${mediaBreakpointMixin('md_gte')} {
    padding-top: ${spaceMixin('lg')};
  }
`;

export const StyledPageContent = styled(PageContent)<{ fluidSmallLTE?: boolean }>`
  margin-top: 0;

  /* PageContent has internal media query - override via custom media query */
  @media ${mediaBreakpointMixin('sm_lte')} {
    padding: ${(props) => props.fluidSmallLTE && 0};
  }
`;

export const StyledTabsPanel = styled(Tabs.Panel)`
  background: none;
  padding: 0;
`;

export const StyledTabsTab = styled(Tabs.Tab)`
  border-color: ${token('colors.white')};
  &&,
  &&[aria-selected='true'] {
    padding: 0;
  }
`;

export const StyledMoreSpacer = styled(Spacer)`
  color: ${token('colors.textMedium')};
`;
